(function() {
  define('tlhServicesFile',['angular'], function() {
    'use strict';
    return angular.module('tlhServicesFile', []).factory('TlhFileService', [
      '$q', function($q) {
        var factory;
        factory = {};
        factory.getFileDataUrl = function(file) {
          return $q(function(resolve) {
            var reader;
            reader = new FileReader();
            reader.onload = function(e) {
              return resolve(e.target.result);
            };
            return reader.readAsDataURL(file);
          });
        };
        factory.getFileBlob = function(file) {
          var URL;
          URL = window.URL || window.webkitURL;
          return URL.createObjectURL(file);
        };
        return factory;
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=file.js.map
;
